import { render, staticRenderFns } from "./shop-purchase-gift.vue?vue&type=template&id=2644f7bc&scoped=true&"
import script from "./shop-purchase-gift.vue?vue&type=script&lang=js&"
export * from "./shop-purchase-gift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2644f7bc",
  null
  
)

export default component.exports